export const MARKETSTORE_CATEGORIES_ATTEMPT = "MARKETSTORE_CATEGORIES_ATTEMPT";
export const MARKETSTORE_CATEGORIES_SUCCESS = "MARKETSTORE_CATEGORIES_SUCCESS";
export const MARKETSTORE_CATEGORIES_FAILED = "MARKETSTORE_CATEGORIES_FAILED";
export const LOGOUT = "LOGOUT";
